  <template>
  <div>
<div class="webinar-wrapper">
  <v-row>

    <v-col cols="9">
      <div v-if="shouldShowChip || webinar.showZugabe" class="mb-2">
    <v-chip  v-if="shouldShowChip" class="mr-2 webinar-chip"  color="green" variant="flat"><h2 class="text-white">Sie sind Teilnehmer</h2></v-chip>
    <v-chip  v-if="webinar.showZugabe"   color="green" class="webinar-chip" variant="flat"><h2 class="text-white">Zusatztermin</h2></v-chip>
     <br> </div>
    <div class="mb-3">
     <div class="webinar-tag">
       <v-icon start icon="mdi-account-tie" color="primary"></v-icon>
       <span style="font-weight: 600; font-size: 15px;" color="primary">{{ webinar.webi_dozent }}</span>
     </div>
   </div>
    <h3>{{ webinar.title }}
    </h3>
<router-link v-if="showLinkDetails" :to="`/webinar/${webinar.wter_webinar_id}`">alle Infos zu diesem  Webinar anzeigen...</router-link>
    <v-row v-if="teilnehmer && teilnehmer.length > 0" >
    <v-col cols="12"><br>
  <b>Teilnehmer: </b>
    <span v-for="t in visibleTeilnehmer" :key="t.wteil_id">
      {{ formatTeilnehmerAnzeige(t) }} |
    </span>
    <span v-if="teilnehmer.length > maxVisible && !showAll">
      ... und <b class="text-green">{{ teilnehmer.length - maxVisible }}</b> weitere
        <b><a   @click="toggleShowAll"> ... mehr anzeigen</a></b>
    </span>
    <span v-if="showAll">
      <span v-for="t in hiddenTeilnehmer" :key="t.wteil_id">
        {{ formatTeilnehmerAnzeige(t) }} |
      </span>
      <b><a   @click="toggleShowAll"> ... weniger anzeigen</a></b>
      </span>
      </v-col>
  </v-row>
<v-row v-if="webinar.status == 1">
  <v-col cols="12">
  <v-btn class="my-4" color="primary" v-if="!shouldShowChip && !userData && webinar.status == 1" @click="showLogin = true">jetzt kostenlos anmelden</v-btn>
  <v-btn class="my-4" color="primary" v-if="!shouldShowChip && userData && webinar.status == 1" @click="showAnmelden = true">jetzt kostenlos anmelden</v-btn>
 </v-col>
</v-row>

    </v-col>
    <v-col cols="3">
    <b>{{ webinar.beginn }}</b><br>
    
    <div
      class="webinar-status"
      :class="`status-${webinar.status}`"
    >
      <b>{{ webinar.statusText }}</b>
    </div>
  
    </v-col>
  </v-row>
</div>
  <v-dialog v-model="showLogin" width="666">
      <v-card>
        <v-card-text>
          <LoginView  />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAnmelden" width="666">
      <v-card >
        <v-card-text class="my-4">
          <h2>Jetzt kostenlos anmelden | {{ webinar.beginn }}</h2>
          {{webinar.title}}<br>
          <br>
          <v-form ref="form" >
            <v-text-field
              v-model="insertTeilnahme.wteil_pers_email"
              :error-messages="formError.wteil_pers_email"
              @blur="validateTeilnehmerEmail"
              @input="validateForm"
              label="An welche E-Mail sollen wir Ihnen den Teilnahme-Link senden"
           
            ></v-text-field>

            <v-text-field
              v-model="insertTeilnahme.wteil_pers_name"
              :error-messages="formError.wteil_pers_name"
              @input="validateForm"
              label="Wer nimmt an diesem Webinar teil"
            ></v-text-field>

            <v-radio-group class="pl-4 ma-0" v-model="insertTeilnahme.wteil_pers_type">
              <v-radio
                key="0"
                label="Sie sind Zahnarzt/Zahnärtin"
                color="green"
                :value="1"
              ></v-radio>
              <v-radio      
                key="1"
                label="Praxis-Mitarbeiter/in"
                color="green"
                :value="2"
              ></v-radio>
            </v-radio-group>

            <v-btn color="primary" @click="insertTeilname"
              >jetzt kostenlos anmelden</v-btn
            >
            <v-row v-if="showFormError">
             
             <v-col cols="12" class="my-2" >
               <ul>
                 <li v-for="error in formErrors" :key="error">
                   <span v-if="error" class="error">{{ error }}</span>
                 </li>
               </ul>
             </v-col>
           </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  </template>

  <script setup>
import { defineProps,inject,onMounted,ref, computed, watchEffect } from "vue";
  import { storeToRefs } from 'pinia';
  import  LoginView from '@/components/objects/user/LoginView.vue'
  import regexHelper from '@/plugins/regexHelper';
  const baseCalls = inject('baseCalls')
  const loaderStore = inject('loaderStore');
  const successStore = inject('successStore');
  const errorStore = inject('errorStore');
  const userStore = inject('userStore')
  const { userData } = storeToRefs(userStore);
  const showLogin = ref(false);
  const showAnmelden = ref(false);
const fallbackOrte = ['München', 'Karlsruhe', 'Stuttgart', 'Bochum', 'Berlin', 'Krefeld'];
const teilnehmerOrtCache = new WeakMap();

const props = defineProps({
    webinar: {
      type: Object,
      required: true
    },
    showLinkDetails: {
      type: Boolean,
    }
  })
  console.log(props.showLinkDetails)
  const teilnehmer = ref([])



  const insertTeilnahme = ref({
    action: "insertTeilnahme",
    wteil_wtb_user_id: 0,
    wteil_termin_id: props.webinar.wter_id,
    wteil_webinar_id: props.webinar.wter_webinar_id,
    wter_count_in: props.webinar.wter_count_in,
    wteil_pers_email: "",
    wteil_pers_name: "",
    wteil_pers_type: 1,
    beginn: props.webinar.beginn,
    title: props.webinar.title,
  });
  const submitStarted = ref(false);
  const formErrors = ref([]);
  const formError = ref({});
  const showFormError = ref(false);
  const maxVisible = 15;
  const showAll = ref(false);

  const visibleTeilnehmer = computed(() => {
    return teilnehmer.value.slice(0, maxVisible);
  });

  const hiddenTeilnehmer = computed(() => {
    return teilnehmer.value.slice(maxVisible);
  });

  const shouldLoadTeilnehmer = computed(() => {
    return Number(props.webinar?.status || 0) !== 2;
  });

  async function getTeilnehmer() {
    let data = {
      action: props.showLinkDetails ? 'getallteilnehmervorschau' : 'getallteilnehmer',
      id: props.webinar.wter_id
    }
    const response = await baseCalls.webinareGet(data)
    if (response.data.teilnehmer) {
      teilnehmer.value = response.data.teilnehmer
    } 
  }
async function insertTeilname() {
     // Formular validieren
   submitStarted.value = true;
    validateForm()

  // Prüfen, ob es Fehler gibt
  if (hasErrors()) {
    console.log('Fehler im Formular, Login nicht möglich')
    return
  }


  if (userData.value) {
    loaderStore.setLoader(true, "Ihre Anmeldung wird gespeichert...");
  }
  
  try {
    const currentUserId = Number(userData.value?.user_id || 0);
    const payload = {
      ...insertTeilnahme.value,
      action: 'insertteilnahme',
      wteil_wtb_user_id: currentUserId,
      wteil_user_id: currentUserId,
    };
    
    const response = await baseCalls.webinarePost(payload);
    
    if (response.data && response.data.success) {
      successStore.setSuccess(
        true,
        "Gespeichert",
        "Ihre Anmeldung wurde erfolgreich gespeichert"
      );
      showAnmelden.value = false;
      shouldShowChip.value = true;
    } else {
      throw new Error(response.data.message || "Fehler beim Anlegen der Anmeldung");
    }
  } catch (err) {
    errorStore.setError(
      err.message || "Beim Anlegen der Anmeldung ist ein Fehler aufgetreten"
    );
    console.error("Fehler beim Anlegen der Anmeldung:", err);
  } finally {
    if (userData.value) {
      loaderStore.setLoader(false);
    }
  }
  
}
function validateTeilnehmerEmail() {
   const [showError, textError] = regexHelper.validateEmail(insertTeilnahme.value.wteil_pers_email);

  if (showError === false) {
    // E-Mail ist gültig
    formError.value.wteil_pers_email = '';
    return true;
  } else {
    // E-Mail ist ungültig, validationResult enthält die Fehlermeldung
    formError.value.wteil_pers_email = textError;
    return false;
  }
}
function validateForm() {
  // Initialisiere das Fehlerobjekt
  formErrors.value = [];
  const errors = {
    wteil_pers_email: '',
    wteil_pers_name: '',
  };

  // Hilfsfunktion zur Fehlerbehandlung
  function addError(field, message) {
   
    if (submitStarted.value) {
      errors[field] = message;
    }
    formErrors.value.push(message);
  }

  // Validierung der Eingabefelder
  const [showError, textError] = regexHelper.validateEmail(insertTeilnahme.value.wteil_pers_email);
  if (showError) addError('wteil_pers_email', textError);


  if (!insertTeilnahme.value.wteil_pers_name) {
    addError('wteil_pers_name', 'Bitte geben Sie Ihren Namen ein');
  }



  // Setze die Fehler im formError-Objekt
  formError.value = errors;

  // Überprüfe, ob Fehler vorhanden sind
  showFormError.value = formErrors.value.length > 0 && submitStarted.value;
  if (!showFormError.value) {
    submitStarted.value = false;
  }
}
function hasErrors() {
 
 showFormError.value = Object.values(formErrors.value).some(error => error !== '')
 return Object.values(formErrors.value).some(error => error !== '')
 
}

  function toggleShowAll() {
    showAll.value = !showAll.value;
  }

function getTeilnehmerOrt(teilnehmer) {
  if (teilnehmer?.user_ort && teilnehmer.user_ort.trim() !== '') {
    return teilnehmer.user_ort;
  }
  if (!teilnehmerOrtCache.has(teilnehmer)) {
    const randomIndex = Math.floor(Math.random() * fallbackOrte.length);
    teilnehmerOrtCache.set(teilnehmer, fallbackOrte[randomIndex]);
  }
  return teilnehmerOrtCache.get(teilnehmer);
}

function formatTeilnehmerAnzeige(teilnehmer) {
  const ort = (getTeilnehmerOrt(teilnehmer) || '').trim();
  let role = '';
  if (teilnehmer?.wteil_pers_type <= 1) {
    role = 'Zahnarzt';
  } else if (teilnehmer?.wteil_pers_type === 2) {
    role = 'ZFA';
  }

  if (!role) {
    return ort || '';
  }

  if (!ort) {
    return role;
  }

  if (ort.toLowerCase().startsWith(role.toLowerCase())) {
    return ort;
  }

  return `${role} ${ort}`;
}

  const shouldShowChip = ref(false);

  watchEffect(() => {
    if (userData.value) {
      shouldShowChip.value = teilnehmer.value.some((t) =>
        Number(t.wteil_wtb_user_id || t.wteil_user_id || 0) === Number(userData.value.user_id)
      );
    }
  });

  onMounted(() => {
    if (shouldLoadTeilnehmer.value) {
      getTeilnehmer()
    }
  })

  console.log(props.webinar)
  </script>

  <style scoped>
  .webinar-wrapper {
    background-color: #f5f7fb;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #e1e6ef;
  }
.webinar-chip {
  border-radius: 6px !important;
}
  .webinar-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 6px;
    border: 1px solid #d5ddeb;
    background: #fff;
  }
  .webinar-status {
    display: inline-flex;
    padding: 6px 14px;
    border-radius: 6px;
    color: #fff;
    font-weight: 600;
  }
  .status-1 {
    background: #2e7d32;
  }
  .status-2 {
    background: #ef6c00;
  }
.status-3 {
    background: #c62828;
  }
</style>
